import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	noIssues: {
		id: 'issue-navigator.common.empty-list-icon.no-issues',
		defaultMessage: 'No issues were found matching your search',
		description: 'This message is displayed when no issues matched the search criteria',
	},
	noIssuesIssueTermRefresh: {
		id: 'issue-navigator.common.empty-list-icon.no-issues-issue-term-refresh',
		defaultMessage: 'No issues were found matching your search',
		description: 'This message is displayed when no issues matched the search criteria',
	},
});
